/* WebSocket client for chat/presence. Auto-reconnect with backoff. */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function makeSocket(onMessage) {
  let ws = null;
  let closed = false;
  let backoff = 1000;

  const url = BACKEND_URL.replace(/^http/, "ws") + "/api/ws";

  function connect() {
    if (closed) return;
    try {
      ws = new WebSocket(url);
    } catch (e) {
      scheduleReconnect();
      return;
    }
    ws.onopen = () => {
      backoff = 1000;
    };
    ws.onmessage = (evt) => {
      try {
        const data = JSON.parse(evt.data);
        onMessage?.(data);
      } catch (e) { /* noop */ }
    };
    ws.onclose = () => { if (!closed) scheduleReconnect(); };
    ws.onerror = () => { try { ws?.close(); } catch (e) { /* noop */ } };
  }
  function scheduleReconnect() {
    setTimeout(connect, backoff);
    backoff = Math.min(backoff * 2, 15000);
  }
  connect();

  return {
    send: (obj) => {
      try { ws?.readyState === 1 && ws.send(JSON.stringify(obj)); } catch (e) { /* noop */ }
    },
    close: () => { closed = true; try { ws?.close(); } catch (e) { /* noop */ } },
  };
}
